import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/services/account.service';
import { PaymentsService } from '../services/payments.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-terms-and-conditions-modal',
    templateUrl: './terms-and-conditions-modal.component.html',
    styleUrls: ['./terms-and-conditions-modal.component.css'],
    imports: [RouterLink]
})
export class TermsAndConditionsModalComponent {

  constructor(public activeModal: NgbActiveModal, private accountService: AccountService, private paymentsService: PaymentsService) { }

  itemId = "";

  SetItemId(item) {
    this.itemId = item;
  }

  AcceptTermsAndConditions() {
    this.accountService.acceptTermsAndConditions().subscribe(
      () => {
        if (this.itemId == "")
          return;
        this.paymentsService.checkout(this.itemId).subscribe(
          () => {
          },
          (_error) => {}
        )
      },
      (_error) => {}
    )
  }
}
